import React, { useEffect, useState } from "react";
import { Text } from "@sitecore-jss/sitecore-jss-react";
import { useSelector } from "react-redux";
import AccessibilityIcon from "@clarion/foundation/dist/Theming/icons/AccessibilityIcon";
import "./index.css";
const ReciteMe = ({
  fields
}) => {
  const global = useSelector(state => state.global);
  const [hideButton, setHideButton] = useState(false);
  const handleLoadService = () => {
    if (window.loadService) {
      window.loadService();
    }
    if (global.isTablet) {
      setHideButton(true);
    }
  };
  useEffect(() => {
    let recitemeScript = document.getElementById("reciteme-script");
    if (!recitemeScript) {
      recitemeScript = document.createElement("script");
      recitemeScript.src = "/scripts/reciteme.js";
      recitemeScript.async = true;
      recitemeScript.id = "reciteme-script";
      document.body.appendChild(recitemeScript);
    }
  }, []);
  return /*#__PURE__*/React.createElement("button", {
    className: `recite-me btn ${hideButton ? "recite-me--hide" : ""}`,
    onClick: handleLoadService
  }, /*#__PURE__*/React.createElement("span", {
    className: "recite-me__icon-container"
  }, /*#__PURE__*/React.createElement(AccessibilityIcon, {
    className: "recite-me__icon"
  })), /*#__PURE__*/React.createElement(Text, {
    field: fields.ReciteMeLabel
  }));
};
export default ReciteMe;